import { BiSave } from "react-icons/bi";
import { MdArrowBack } from "react-icons/md";
import ModuleButton from "@components/button/ModuleButton";
import CreateActivityError from "../CreateActivityError";
import type { FC } from "react";

interface FormActionsProps {
	isEdit: boolean;
	isLoading: boolean;
	isValid: boolean;
	isError: boolean;
	onReturn?: () => void;
}

export const FormActions: FC<FormActionsProps> = ({
	isEdit,
	isLoading,
	isValid,
	isError,
	onReturn,
}) => {
	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				gap: "10px",
				marginBottom: "1rem",
				paddingTop: "1rem"
			}}
		>
			{onReturn && (
				<ModuleButton icon={MdArrowBack} buttonType="button" labelKey={isEdit ? "main.back" : "activity.back_to_wizard"} handleClick={onReturn} />
			)}
			<ModuleButton
				icon={BiSave}
				disabled={isLoading || !isValid}
				isLoading={isLoading}
				labelKey={isEdit ? "main.save_changes" : "main.finalize_setup_and_save"}
			/>
			<CreateActivityError
				isError={isError}
				message={isEdit ? "An error occured when saving changes" : undefined}
			/>
		</div>
	);
}; 